import React from 'react';
import { DataTable } from 'primereact/datatable';
import moment from 'moment';
import { Column } from 'primereact/column';
import { StyledBoxTable } from '../../components/layout/main/mainStyles';
import { LoadingRowsComponent } from '../../components/commons/LoadingRows/LoadingRows';
import { UsersLoginCodeTemplateProps } from './userLoginCodeTemplateProps';

export const UsersLoginCodeTemplate = ({
  isLoading,
  isSuccess,
  allUsers,
  selectedItems,
  setSelectedItems
}: UsersLoginCodeTemplateProps) => {
  const getFormattedDate = (rowData: { createdAt: string }) => {
    if (rowData.createdAt) {
      return moment(rowData.createdAt).format('MM/DD/YYYY HH:MM');
    }
    return '';
  };
  const getFormattedDateUntil = (rowData: { validUntil: string }) => {
    if (rowData.validUntil) {
      return moment(rowData.validUntil).format('MM/DD/YYYY HH:MM');
    }
    return '';
  };
  const usedValue = (rowData: { used: boolean }) => {
    return rowData.used ? 'Used' : 'Not Used';
  };
  return (
    <StyledBoxTable>
      {isLoading && <LoadingRowsComponent />}
      {isSuccess && allUsers && (
        <DataTable
          selectionMode="multiple"
          metaKeySelection
          selection={selectedItems}
          value={allUsers ?? []}
          size="small"
          scrollable
          scrollHeight="flex"
          onSelectionChange={(e) => setSelectedItems(e.value)}
          paginator={allUsers && allUsers.length >= 50}
          selectionPageOnly
          rows={50}
          rowsPerPageOptions={[5, 10, 20, 50]}
          tableStyle={{ padding: 0, margin: 0, fontSize: '14px' }}
          className="mt-3"
          rowHover
        >
          <Column field="userName" header="User" sortable />
          <Column field="target" header="Target" sortable />
          <Column field="targetType" header="Type" sortable />
          <Column field="password" header="OPT Code" sortable />
          <Column field="used" header="Status" sortable body={usedValue} />
          <Column
            field="createdAt"
            header="Code Sent Date"
            sortable
            body={getFormattedDate}
          />
          <Column
            field="validUntil"
            header="Deadline"
            sortable
            body={getFormattedDateUntil}
          />
        </DataTable>
      )}
    </StyledBoxTable>
  );
};
